
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { GetServerSideProps } from "next"
import Head from "next/head"
import { ParsedUrlQuery } from "querystring"
import { useEffect } from "react"

import getProduct from "@/graphql/requests/getProduct"
import getProductsByCreatorId from "@/graphql/requests/getProductsByCreatorId"
import getProductPrice from "@/helpers/getProductPrice"
import SEO from "@/meta/SEO"
import Facebook from "@/services/Facebook"
import { GoogleAnalytics } from "@/services/GA4/GoogleAnalytics"
import Default from "@/templates/Default"
import Product from "@/ts/Product"
import ProductView from "@/views/product"

function ProductPage(props: ProductPageProps) {
  const { staticProduct, staticCreatorProducts } = props
  const product = staticProduct?.products[0]
  const price = getProductPrice(product)

  const productDescription =
    product?.description?.replace(/<p[^>]*>/, "$1").slice(0, 130) + "..."

  const tags = product?.tags

  useEffect(() => {
    Facebook.track("ViewContent", {
      value: price?.value / 100,
      currency: price?.currency,
      content_ids: [product.id],
    })
  }, [])

  return (
    <>
      <Head>
        <title>{staticProduct.products[0].name} | fansi.pl</title>
        <SEO description={productDescription} />
        <meta name="tags" content={tags} />
      </Head>
      <GoogleAnalytics />
      <ProductView
        product={staticProduct.products[0]}
        creatorProducts={staticCreatorProducts.products}
      />
    </>
  )
}

 const _getServerSideProps: GetServerSideProps = async ({ params }) => {
  const { slug } = params as Params
  const staticProduct = await getProduct(slug)

  const product = staticProduct.products?.[0]

  if (!product || !product.status || product.status === "deleted")
    return {
      redirect: { permanent: false, destination: "/products/not-found" },
    }

  const staticCreatorProducts = await getProductsByCreatorId(product.creator.id)

  return {
    props: { staticProduct, staticCreatorProducts, slug },
  }
}

ProductPage.Layout = Default

interface ProductPageProps {
  staticProduct: {
    products: Product[]
  }
  staticCreatorProducts: {
    products: Product[]
  }
  slug: string
}
interface Params extends ParsedUrlQuery {
  slug: string
}

export default ProductPage


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/products/[slug]',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  